// @styles
require('./referralsInvitations.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { EmptyState } = require('commonsComponents/emptyState');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @utilities
const { PAGE_NAMES, SECTION_NAME, tagReferralsPage } = require('utilities/taggingReferralsHelper');
const { findActiveFilters } = require('utilities/filtersHelper');
const { conditionalClassName } = require('utilities/conditionals/conditionalClassname');

// @components
const ReferralsTableRow = require('./referralsTableRow');
const ReferralsInvitationsFilter = require('./referralsInvitationsFilter');
const ReferralsInvitationsContentFilters = require('./referralsInvitationsContentFilters');

// @Helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @ constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();


class ReferralsInvitations extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterSettingsOpen: false
        };

        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.setFilters = this.setFilters.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
    }

    componentDidMount() {
        tagReferralsPage(PAGE_NAMES.REFERRALS);
    }

    setFilters(filters) {
        const { getGuardianInvitationInfo, setFilters } = this.props;
        setFilters(filters);
        getGuardianInvitationInfo();
    }

    resetFilter(filter) {
        const { getGuardianInvitationInfo, resetFilter } = this.props;
        resetFilter(filter);
        getGuardianInvitationInfo();
    }

    clearFilters() {
        const { clearFilters, getGuardianInvitationInfo } = this.props;
        clearFilters();
        getGuardianInvitationInfo();
    }

    handleToggleFilters() {
        this.setState(previousState => {
            return {
                filterSettingsOpen: !previousState.filterSettingsOpen
            }
        });
    }

    buildStatusTooltip() {
        const statusPendingClass = conditionalClassName('referrals-invitations__tooltip-value', 'referrals-invitations__tooltip-value--first')
        const statusTooltipContent = (
            <div className="referrals-invitations__tooltip-container">
                <FormattedText
                    className="referrals-invitations__tooltip-title"
                    format="firstUppercase"
                    value="referrals-pending"
                />
                <FormattedText
                    className={statusPendingClass}
                    value="referrals-statusPendingTooltip"
                />
                <FormattedText
                    className="referrals-invitations__tooltip-title"
                    format="firstUppercase"
                    value="referrals-used"
                />
                <FormattedText
                    className="referrals-invitations__tooltip-value"
                    value="referrals-statusUsedTooltip"
                />
                <FormattedText
                    className="referrals-invitations__tooltip-title"
                    value="referrals-conditionsOK"
                />
                <FormattedText
                    className="referrals-invitations__tooltip-value"
                    value="referrals-statusConditionsOKTooltip"
                />
            </div>
        );

        return (
            <OKTooltip
                content={statusTooltipContent}
                offset={[0, 15]}
                type="custom"
                placement="bottom"
            />
        );
    }

    buildReferralsTable() {
        const { immReferrals } = this.props;
        const immReferralsById = immReferrals.get('byId');
        const immReferralsFilters = immReferrals.get('filters');
        
        let headerButtons;
        let response;
        let immReferralsByOrder = immReferrals.get('byOrder');


        headerButtons = (
            <div
                className="referrals-invitations__add-referral"
                data-gtns-component-name={`${SECTION_NAME} - ${PAGE_NAMES.REFERRALS}`}
            >
                <OKButton modifier="task" onClick={this.handleToggleFilters}>
                    <i className="icon icon-filtrar referrals-invitations__filter-settings-icon" />
                </OKButton>
            </div>
        );

        if (immReferralsByOrder.size > 0) {
            const tableCell = (
                <span>
                    <FormattedText value="referrals-date" />
                </span>
            );

            const statusTooltip = this.buildStatusTooltip();
            const plainAmountObject = getPlainAmountObject(immReferrals.get('totalAmountEarned'));
            plainAmountObject.decimalsLength = 0;
            response = (
                <section className="referrals-invitations__table">
                    <LastMovementsTable
                        groupByDate={true}
                        rowComponent={ReferralsTableRow}
                        immTransactionsByOrder={immReferralsByOrder}
                        immTransactionsById={immReferralsById}
                        id={'referrals-table'}
                        columnsCount={5}
                        currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                        language={language}
                    >
                        <thead>
                            <OKTableRow asHeader={true}>
                                <OKTableCell asHeader={true}>
                                    <OKTooltip
                                        content="referrals-tooltipDate"
                                        target={tableCell}
                                        offset={[0, -10]}
                                        type="descriptive"
                                    />
                                </OKTableCell>
                                <OKTableCell asHeader={true}>
                                    <FormattedText value="referrals-promoName" />
                                </OKTableCell>
                                <OKTableCell asHeader={true}>
                                    <FormattedText value="referrals-giftType" />
                                </OKTableCell>
                                <OKTableCell asHeader={true}>
                                    <FormattedText value="referrals-code" />
                                </OKTableCell>
                                <OKTableCell asHeader={true}>
                                    <FormattedText value="referrals-status" />
                                    {statusTooltip}
                                </OKTableCell>
                                <OKTableCell asHeader={true}>
                                    <FormattedText value="referrals-gift" />
                                </OKTableCell>
                            </OKTableRow>
                        </thead>
                    </LastMovementsTable>
                    <div className="referrals-invitations__total-amount">
                        <FormattedText
                            value="referrals-totalAmountEarned"
                            className="referrals-invitations__total-amount-text" />
                        &nbsp;
                        <span className="referrals-invitations__total-amount-value">
                            <OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                language={language}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                            />
                        </span>
                    </div>
                </section>
            );
        } else {
            if (findActiveFilters(immReferralsFilters)) {
                response = (<EmptyState primaryText={formatText('referrals-invitationsFilterEmpty')} iconType="search-banking" />);
            }
            else {
                response = (
                    <div className="referrals-invitations__empty-state">
                        <EmptyState primaryText={formatText('referrals-noneForThisPromo')} iconType="search-banking" />
                    </div>
                );
            }
        }

        return (
            <section className="referrals-invitations__content">
                {headerButtons}
                <ReferralsInvitationsContentFilters
                    clearFilters={this.clearFilters}
                    immFilter={immReferralsFilters}
                    resetFilter={this.resetFilter}
                />
                {response}
            </section>
        );
    }

    render() {
        const { getGuardianInvitationInfo, immReferrals } = this.props;
        let content;

        if (immReferrals.get('referralsIsFetching')) {
            content = (<LoadingSection />);
        } else if (immReferrals.get('referralsError')) {
            const retryButton = (
                <OKButton onClick={getGuardianInvitationInfo}>
                    <FormattedText value="common-retry" />
                </OKButton>
            );
            content = (
                <div className="referrals-invitations__empty-state">
                    <EmptyState primaryText={formatText('referrals-errorState')} button={retryButton} iconType="nointernet-banking" />
                </div>
            );
        } else if (immReferrals.get('referralsSuccess')) {
            content = this.buildReferralsTable();
        }

        return (
            <div className="referrals-invitations">
                <ReferralsInvitationsFilter
                    immFilter={immReferrals.get('filters')}
                    immGiftTypes={immReferrals.get('giftTypes')}
                    isOpen={this.state.filterSettingsOpen}
                    onCloseClick={this.handleToggleFilters}
                    setFilters={this.setFilters}
                />
                {content}
            </div>
        );
    }
}

ReferralsInvitations.propTypes = {
    clearFilters: PropTypes.func.isRequired,
    getGuardianInvitationInfo: PropTypes.func.isRequired,
    immReferrals: PropTypes.object.isRequired,
    resetFilter: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
};

module.exports = ReferralsInvitations;
